import { Modal, Form, IFormContext } from 'rewire-ui';
import { FieldFilter, INameLike, ScheduleFilterInput } from '../DataTypes';
import { RouteManagerBase } from '../main-navigation/RouteManager';
import { IScheduleFilters } from '../schedule/ScheduleControlsModel';
import { getNameSearcher } from '../utility/Searchers';

export class AdvancedSearchDialogModel extends Modal {
  form: Form;
  constructor() {
    super('Advanced Search');

    // const modeSearcher       = arraySearch(Object.keys(FilterModes), (item?: any) => (item) || '');
    const groupFilter = () =>
      this.form.field.areas.value?.length
        ? ({ field: 'areaId', in: this.form.field.areas.value.map((area: INameLike) => area.id) } as FieldFilter)
        : undefined;

    const areaSearcher = getNameSearcher('areas');
    const groupSearcher = getNameSearcher('groups', groupFilter);
    const occupationSearcher = getNameSearcher('occupations');
    const employeeSearcher = getNameSearcher('employees');
    const generatorSearcher = getNameSearcher('generators');
    const templateSearcher = getNameSearcher('templates');
    const reasonSearcher = getNameSearcher('reasons');
    this.form = Form.create(
      (form: IFormContext) => ({
        areas: form.multiselectautocomplete(areaSearcher, { chipLimit: 2 }).label('Area').placeholder('select Area(s)').autoFocus(),
        groups: form.multiselectautocomplete(groupSearcher, { chipLimit: 2 }).label('Group').placeholder('select Group(s)'),
        occupations: form
          .multiselectautocomplete(occupationSearcher, { chipLimit: 2 })
          .label('Occupation')
          .placeholder('select Occupation(s)'),
        assignedEmployees: form
          .multiselectautocomplete(employeeSearcher, { chipLimit: 2 })
          .label('Assigned Employee')
          .placeholder('select Assigned Employee(s)'),
        employees: form
          .multiselectautocomplete(employeeSearcher, { chipLimit: 2 })
          .label('Employee')
          .placeholder('select Employee(s)'),
        generators: form
          .multiselectautocomplete(generatorSearcher, { chipLimit: 2 })
          .label('Shift Pattern')
          .placeholder('select Shift Pattern(s)'),
        templates: form
          .multiselectautocomplete(templateSearcher, { chipLimit: 2 })
          .label('Shift Type')
          .placeholder('select Shift Type(s)'),
        reasons: form.multiselectautocomplete(reasonSearcher, { chipLimit: 2 }).label('Reason').placeholder('select Reason(s)'),
      }),
      {},
      { disableErrors: true },
    );
    this.action('cancel').action('search', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load(filterData?: IScheduleFilters) {
    this.reset();
    if (filterData) {
      this.form.value = {
        ...filterData,
      };
    }
    this.open();
  }

  submit = () => {
    if (!this.form.submit()) return false;
    const newFilters = {
      ...this.form.toObjectValues(),
    };
    for (const key of Object.keys(newFilters)) {
      if (!newFilters[key]?.length) {
        delete newFilters[key];
      }
    }

    const filterIds: ScheduleFilterInput = {};
    for (const key of Object.keys(newFilters)) {
      filterIds[`${key.substr(0, key.length - 1)}Ids` as keyof ScheduleFilterInput] =
        (newFilters[key]?.length &&
          newFilters[key].map((searchEntity: INameLike) => {
            return searchEntity.id;
          })) ||
        undefined;
    }

    setTimeout(
      () => RouteManagerBase.current.navigateTo({ filters: filterIds, areaId: undefined, groupId: undefined, viewId: undefined }),
      0,
    );
    return true;
  };
}

const advancedSearchDialogModel = new AdvancedSearchDialogModel();
export default advancedSearchDialogModel;
